import axios from 'axios';
import * as Cookies from 'es-cookie';
import jwt_decode from 'jwt-decode';

import AuthModel from 'src/model/auth.model';
import BaseModel from 'src/model/base.model';
import TokenModel from 'src/model/token.model';
import UserModel from 'src/model/user.model';
import env from 'src/shared/env';

class TokenService extends BaseModel {
  private baseURL: string = env.REACT_APP_BASE_API_URL;

  constructor() {
    super();
  }

  public setToken(token: TokenModel) {
    return new Promise((resolve, reject) => {
      try {
        const tokenDecoded = this.castTokenToClass(
          this.decodeToken(token.accessToken)
        );
        const activeAccount = tokenDecoded.accountId
          ? tokenDecoded.accountId
          : tokenDecoded.sub;
          localStorage.removeItem('accessSuperToken');
          localStorage.removeItem('gblSuperId');
        const promises = [
          localStorage.removeItem('accessToken'),
          localStorage.removeItem('refreshToken'),
          localStorage.removeItem('activeAccount'),
          localStorage.removeItem('activeAccountCountry'),
          localStorage.setItem('accessToken', token.accessToken),
          localStorage.setItem('refreshToken', token.refreshToken),
          localStorage.setItem('activeAccount', activeAccount),
          localStorage.setItem(
            'activeAccountCountry',
            env.REACT_APP_BASE_ENVIRONMENT
          ),
          Cookies.set('accessToken', token.accessToken, { path: '/' })
        ];
        Promise.all(promises)
          .then(data => {
            const isSuperUserForPartSmart = tokenDecoded?.permission.includes("SUPER_USER");
            const isPowerUserForPartSmart = tokenDecoded?.permission.includes("POWER_USER");
            if (isSuperUserForPartSmart || isPowerUserForPartSmart) {
            console.log("====Yes token Access Set ",tokenDecoded);

              localStorage.setItem('accessSuperToken', token.accessToken);
            }
            resolve(true);
          })
          .catch(error => {
            reject(error);
          });
      } catch (error) {
        reject(error);
      }
    });
  }

  public getAccessToken() {
    return new Promise((resolve, reject) => {
      try {
        resolve(localStorage.getItem('accessToken'));
      } catch (error) {
        reject(error);
      }
    });
  }

  public getRefreshToken() {
    return new Promise((resolve, reject) => {
      try {
        resolve(localStorage.getItem('refreshToken'));
      } catch (error) {
        reject(error);
      }
    });
  }

  public getSignInStatus() {
    return (
      'accessToken' in localStorage &&
      'refreshToken' in localStorage &&
      'activeAccount' in localStorage &&
      'activeAccountCountry' in localStorage
    );
  }

  public refreshToken() {
    return new Promise((resolve, reject) => {
      this.getRefreshToken().then(refreshToken => {
        axios({
          baseURL: this.baseURL,
          method: 'get',
          url: '/accountapp/v1/security/api/auth/token',
          headers: {
            Authorization: `Bearer ${refreshToken}`
          }
        })
          .then((response: any) => {
            const res = BaseModel.cast<AuthModel>(response.data, BaseModel);
            this.setToken(res);
            resolve();
          })
          .catch(e => {
            reject(e);
          });
      });
    });
  }

  public decodeToken(token: string) {
    return jwt_decode(token);
  }

  public logOut() {
    return new Promise((resolve, reject) => {
      try {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('activeAccount');
        localStorage.removeItem('activeAccountCountry');
        Cookies.remove('accessToken');
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  public castTokenToClass(tokenData: any): any {
    const newUser = new UserModel();
    newUser.sub = tokenData.sub;
    newUser.accountId = tokenData.accountId;
    newUser.permission = tokenData.scopes;
    newUser.tokenEmittedIn = tokenData.iat;
    newUser.tokenExpiration = tokenData.exp;
    return newUser;
  }
}

const tokenServiceInstance = new TokenService();
Object.freeze(tokenServiceInstance);

export default tokenServiceInstance;
